<template>
  <div class="container">
    <div class="formulario">
      <div class="titulo"><h2>{{ titulo }}</h2></div>
      <div class="dadosHistorico" v-if="historicoRequerimento.length > 0">
        <b-alert class="negrito" show><b-icon icon="file-text"  class="mr-1" /> Dados do Requerimento</b-alert>
        <div class="">
          <div><span class="label">Nome:</span> {{ dadosRequerimento.nome_solicitante }}</div>
          <div><span class="label">Código do Requerimento:</span> {{ dadosRequerimento.numero_solicitacao }}</div>
          <div><span class="label">Descrição:</span> {{ dadosRequerimento.descricao_solicitacao }}</div>
        </div>
        <div>
          <span class="label">Tipo do Requerimento:</span>
          <ul>
          <li v-for="solicitacao in tipoSolicitacaoRequerimento">
              {{ solicitacao.descricao}}
          </li>
          </ul>
        </div>
        <b-alert class="negrito mt-20" show><b-icon icon="file-text"  class="mr-1" /> Histórico do Requerimento</b-alert>
        <b-table
            :items="historicoRequerimento"
            :fields="fields"
            striped
            bordeless
            head-variant="light"
        />
      </div>
    </div>
  </div>
</template>

<script>

import api from '../api'

export default {

  data () {
    return {
      titulo: 'Acompanhamento do Requerimento LGPD',
      fields: [{ key: 'data_hora', label: 'Data/Hora'}, { key: 'descricao', label: 'Descrição' }],
      dadosRequerimento: {},
      tipoSolicitacaoRequerimento: {},
      historicoRequerimento: []
    }
  },

  created() {
    this.getHistoricoRequerimento(this.$route.query.t)
  },

  methods: {

    getHistoricoRequerimento(token) {
      api
        .get('/tokenacesso/' + token, {
          headers: {
            "Content-Type": "application/json; charset=utf-8",
          },
        })
        .then(res => {
        //console.log(res)
        if (res.status === 200) {
          this.dadosRequerimento = res.data.solicitacao[0]
          this.tipoSolicitacaoRequerimento = res.data.tipoSolicitacao
          this.historicoRequerimento = res.data.historico
        } else if (res.status === 204){
            this.$bvModal.msgBoxOk('❌Clique em Acompanhamento do Requerimento para gerar um novo link de acesso', {
              title: 'Link inválido',
              size: 'sm',
              buttonSize: 'sm',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true
            })
        }

        })
        .catch(res => {
          //console.log(res)
          if (res.response.status === 403) {
            this.$bvModal.msgBoxOk('❌Clique em Acompanhamento do Requerimento para gerar um novo link de acesso', {
              title: 'Link expirado',
              size: 'sm',
              buttonSize: 'sm',
              headerClass: 'p-2 border-bottom-0',
              footerClass: 'p-2 border-top-0',
              centered: true
           })
          } else if (res.response.status === 400) {
              this.$bvModal.msgBoxOk('❌Clique em Acompanhamento do Requerimento para gerar um novo link de acesso', {
                title: 'Link inválido',
                size: 'sm',
                buttonSize: 'sm',
                headerClass: 'p-2 border-bottom-0',
                footerClass: 'p-2 border-top-0',
                centered: true
              })
          }

        })
    },
  }
}
</script>

<style scoped>
.label {
  font-weight: bold;
}
.mt-20 {
  margin-top: 20px;
}
.container {
  background-color: #f8f9fa!important;
}
.negrito {
  font-weight: bold;
}

.formulario {
  width: 80%;
  margin: auto;
  background-color: #f8f9fa !important;
  min-height: 100vh;
}

.titulo {
  margin-top: 20px;
  margin-bottom: 6em;

}

label.d-block {
  font-weight: bold;
}

.container {
  margin: 0px;
  background-color: #f8f9fa !important;
}

.negrito {
  font-weight: bold;
}

.custom-file-input {
  /* opacity: 100; */
}

.alert-info {
  background-color: transparent;
  border-color: transparent;
}

.alert {
  padding: 0px;
}

.dadosHistorico {
  background-color: white;
  padding-top: 2em;
  padding-left: 2em;
  padding-right: 2em;
}

@media (max-width: 678px) {
  .titulo {
    margin-bottom: 0px;
  }

  .titulo h2{
    font-size: 1.5rem;
  }
}

.modal-body {
  white-space:break-spaces;
}


.modal-content {
  width: fit-content!important;
}

</style>



// WEBPACK FOOTER //
// src/views/AcompanhamentoHistorico.vue